import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import ProfileEdit from './views/ProfileEdit'
import ProfileView from './views/ProfileView'
import Settings from './views/Settings'
import Notice from './views/Notice'
import Login from './views/Login'
import Index from './views/Index'
import Join from './views/Join'
import LostPassword from './views/LostPassword'

import ConsultTelPopup from './views/ConsultTelPopup'; //전화상담팝업

import ImageViewer from './components/Common/ImageViewer';

import ConsultTel from './views/ConsultTel'; //전화상담
import ConsultTelMonit from './views/ConsultTelMonit'; //전화상담현황

import ConsultTelNew from './views/ConsultTelNew'; //전화상담(new)
import ConsultTelMonitNew from './views/ConsultTelMonitNew'; //전화상담현황(new)

import ConsultPharm from './views/ConsultPharm'; //조제배송내역
import ConsultPharmMonit from './views/ConsultPharmMonit'; //조제배송내현황

import ConsultDrAdmin from './views/ConsultDrAdmin'; 
import DrProfileEdit from './components/DrAdmin/ProfileEdit';  //관리자 프로필 수정

import Settle from './views/Settle';
import ConsultMemo from './views/ConsultMemo';  //간단문의
import Location from './components/Common/Location';
import Account from './views/Account'
import PharmacistListAdmin from './views/PharmacistListAdmin';

// import Testing from './views/Testing.vue';
import auth from '@/lib/auth_client';

Vue.use(Router)

// export default new Router({
const router = new Router({
  routes: [
    { path: '/',                                    name: 'index',                component: Index, meta: { requiredAuth: false, side: false, top: false, container: false }},
    { path: '/home',                                name: 'home',                 component: Home, meta: { requiredAuth: true } },
    { path: '/profile',                             name: 'profile-view',         component: ProfileView, meta: { requiredAuth: true } },
    { path: '/profile/edit',                        name: 'profile-edit',         component: ProfileEdit, meta: { requiredAuth: true } },
    { path: '/settings/:sub_page?',                 name: 'settings',             component: Settings, meta: { requiredAuth: true } }, // sub_page는 optional
    { path: '/notice',                              name: 'notice',               component: Notice, meta: { requiredAuth: true }},
    { path: '/login',                               name: 'login',                component: Login, meta: { requiredAuth: false, side: false, container: false }},
    { path: '/join/:step_no',                       name: 'join',                 component: Join, meta: { requiredAuth: false, side: false, container: false }, props: true},
    { path: '/lostpass/:step_no',                   name: 'lost-password',        component: LostPassword, meta: { requiredAuth: false, side: false, container: false }, props: true},
    { path: '/tmonit',                              name: 'tel-consult-monit',    component: ConsultTelMonit, meta: { requiredAuth: true } },
    { path: '/tmonit-new',                          name: 'tel-consult-monit-new',    component: ConsultTelMonitNew, meta: { requiredAuth: true } },
    { path: '/consult-pharm-monit',                 name: 'consult-pharm-monit',    component: ConsultPharmMonit, meta: { requiredAuth: true } },
    { path: '/consult-tel',                         name: 'consult-tel',          component: ConsultTel, meta: { requiredAuth: true } },
    { path: '/consult-pharm',                       name: 'consult-pharm',      component: ConsultPharm, meta: { requiredAuth: true } },
    { path: '/consulttel_popup/:note_id',           name: 'consult-tel-pop',      component: ConsultTelPopup, meta: { top: false, side: false, container: false }, props: true},
    { path: '/imageview',                           name: 'image-viewe',          component: ImageViewer, meta: { top: false, side: false, container: false }, props: (route) => ({ query: route.query.image_url }) },
    { path: '/dr_admin/:sub_page?',                 name: 'dr-admin',             component: ConsultDrAdmin, meta: { requiredAuth: true }, props: true }, // sub_page는 optional
    { path: '/dr_admin/dr_edit/:dr_id',             name: 'dr-profile-edit',      component: DrProfileEdit, meta: { top: false, side: false, container: false, requiredAuth: true }, props: true },
    { path: '/settle/:settle_type',                 name: 'settle',               component: Settle},
    { path: '/location',                            name: 'location',             component: Location, meta: { requiredAuth: false, top: false, side: false, container: false }, props: true},
    { path: '/consult_memo',                        name: 'consult_memo',         component: ConsultMemo, meta: { requiredAuth: true } },
    { path: '/account',                             name: 'account',              component: Account, meta: { requiredAuth: true } },
    { path: '/pharmacist-list',                     name: 'pharmacist-list-admin',        component: PharmacistListAdmin, meta: { requiredAuth: true }, props: true},
  ]
})

router.beforeEach((to, from, next) => {
  // if (to.matched.some(record => record.meta.requiresAuth)) {
  let { requiredAuth = false } = to.matched[0].meta;
  // console.log(requiredAuth)

  if (requiredAuth && !auth.isLoggedIn()) { // 로그인필요 + 로그인 안된상태
    next({path: '/login', query: {redirect: to.fullPath}})
  }

  // Todo: api가 튕길경우 강제로 logout되는 기능이 필요하다.
  next();
})


export default router